class ManagedIframe {
  constructor(pluginUrl) {
    this.pluginUrl = pluginUrl;
  }

  build() {
    this.iframe = document.createElement('iframe');
    return this;
  }

  appendTo(element) {
    element.appendChild(this.getIframe());
    return this;
  }

  styleToFullscreen() {
    Object.entries({
      background: 'none',
      border: 'none',
      width: '100%',
      height: '100%',
    }).forEach((rule) => this.getIframe().style.setProperty(...rule));
    return this;
  }

  addFullscreenPermission() {
    this.getIframe().setAttribute('allow', 'fullscreen');
    // Some of the browsers still looks for allowfullscreen
    this.getIframe().setAttribute('allowfullscreen', '');
    return this;
  }

  addTitle(title) {
    this.getIframe().setAttribute('title', title);
  }

  addClass(className) {
    this.getIframe().classList.add(className);
  }

  load() {
    this.iframe.src = this.pluginUrl;
  }

  getIframe() {
    if (!this.iframe) {
      throw new Error('Attempted to access an iframe before it was declared');
    }
    return this.iframe;
  }
}

export default ManagedIframe;
